import Phaser from 'phaser'
import Player, { WIDTH, HEIGHT, CRASH_ROTATION_SPEED } from './player'
import { LAYER_CARS, LAYER_EMOTE } from '../layers'

export const COLORS = ['black', 'blue', 'green', 'red', 'yellow']
export const MODELS = [1, 2, 3, 4, 5]

const SIDE_SPEED = 200

export default class Car extends Phaser.GameObjects.Container {
  constructor (scene, evil = false) {
    super(scene)
    this.player = scene.player

    const model = scene.rnd.pick(MODELS)
    const color = scene.rnd.pick(COLORS)

    this.image = this.scene.add.image(0, 0, 'cars', `car_${color}_${model}`)
    this.image.setSize(WIDTH, HEIGHT)
    this.image.setDisplaySize(WIDTH, HEIGHT)
    this.add(this.image)

    this.escaped = false
    this.speed = 100
    this.isHit = false
    this.lane = -1

    this.switchLaneDir = 1
    this.switchLaneDuration = 0

    if (evil) {
      this.setEvil()
    }

    this.setDepth(LAYER_CARS)

    this.on('collision', other => this.onCollision(other))

    this.id = Math.round(this.scene.rnd.frac() * 1000)
    // if (process.env.NODE_ENV !== 'production') {
    //  var t = this.scene.add.text(-10, 50, this.id)
    //  this.add(t)
    // }
  }

  setEvil () {
    if (!this.evil) {
      this.evil = true
      this.emote = this.scene.add.image(0, -100, 'hud', 'exclamation')
      this.emote.setScale(1)
      this.emote.setDepth(LAYER_EMOTE)
      this.emote.setOrigin(0.7, 1)
    }
  }

  initialize () {
    // maybe not needed anymore, as we're also doing this in update
    this.body.setOffset(-this.image.width * 0.5, -this.image.height * 0.5)
    this.body.setSize(this.image.width * 1.0, this.image.height * 1.0)

    this.body.velocity.y = -this.speed
  }

  onCollision (other) {
    if (other instanceof Player) {
      if (this.evil) {
        this.player.emit('hit', this)
      } else {
        if (!this.player.godMode) {
          this.player.collidedWith(this)
          this.scene.gameover()
        }
      }

      if (!this.isHit) {
        if (this.body.velocity.x === 0) {
          this.body.velocity.x = other.x < this.x ? 150 : -150
          this.body.velocity.y += other.body.velocity.y
        }
        this.scene.cameraController.cam.shake(100, 0.01)
        this.body.checkCollision.none = true
      }
      this.isHit = true
    }
  }

  preUpdate (time, delta) {
    var targetSpeed = -this.speed

    this.body.velocity.y = this.body.velocity.y + (targetSpeed - this.body.velocity.y) * (delta * 0.005)

    if (this.isHit) {
      this.showEmote = 'anger'
      this.angle += this.body.velocity.x * delta * CRASH_ROTATION_SPEED
    }

    // get current lane:
    const current = this.scene.road.getSectionAt(this.y)
    if (current) {
      const lanes = this.scene.road.getLanesAt(this.y)
      const halfLane = current.laneWidth / 2
      this.lane = -1
      lanes.forEach((l, i) => {
        if (this.x > l - halfLane && this.x < l + halfLane) {
          this.lane = i
        }
      })
    }

    if (!this.isHit) {
      if (this.lane === -1) {
        this.switchLane(this.x < 100 ? 1 : -1)
      }

      // look behind to make sure to stay out of the player's way if he hasn't moved yet:
      if (!this.player.hasMoved && this.player.lane === this.lane) {
        var sensePlayer = this.scene.physics.overlapRect(this.x - WIDTH / 2, this.y, WIDTH, 600, true, false)
        if (sensePlayer && sensePlayer.length > 0) {
          if (sensePlayer[0].gameObject instanceof Player) {
            this.switchLane(this.lane === 0 ? 1 : -1)
          }
        }
      }

      // look behind to see if I'm getting bumped by another car
      var senseCars = this.scene.physics.overlapRect(this.x - WIDTH / 2, this.y, WIDTH, 600, true, false)
      if (senseCars && senseCars.length > 0) {
        if (senseCars[0].gameObject instanceof Car && senseCars[0].gameObject.id !== this.id && senseCars[0].velocity.y < this.body.velocity.y) {
        // the car behind me is going faster than me. Lets slow him down
          senseCars[0].gameObject.speed = -this.body.velocity.y - 10
          senseCars[0].velocity.y = -senseCars[0].gameObject.speed
        }
      }

      let targetAngle = 0
      if (this.switchLaneDuration > 0) {
        this.switchLaneDuration -= delta
        this.body.velocity.x = this.switchLaneDir * SIDE_SPEED

        targetAngle = this.switchLaneDir * 25 * (this.switchLaneDuration / ((90 / SIDE_SPEED) * 1000))

        if (this.switchLaneDuration <= 0) {
          this.body.velocity.x = 0
        }
      }
      this.angle += (targetAngle - this.angle) * (delta * 0.01)
    }

    if (this.evil) {
      this.emote.x = this.x
      this.emote.y = this.y - this.image.displayHeight / 2 - 3
      this.emote.setVisible(!!this.showEmote)
      this.emote.setFrame(this.showEmote)

      if (this.y > this.scene.player.y + 50) {
        if (!this.isHit) {
          this.showEmote = 'haha'
          if (!this.escaped) {
            this.escaped = true
            this.player.emit('missed')
          }
        }
      } else {
        if (this.scene.cameraController.isLookingAhead()) {
          this.showEmote = 'exclamation'
        } else {
          this.showEmote = null
        }
      }
    }

    if (this.y > this.scene.player.y + 1000) {
      this.destroy()
    }
  }

  switchLane (dir) {
    if (this.switchLaneDuration <= 0) {
      this.switchLaneDir = dir
      this.switchLaneDuration = (90 / SIDE_SPEED) * 1000

      // TODO: maybe add a collision check to the side to make sure I'm not bumping into anyone..
    }
  }
}
